import { Injectable } from '@angular/core';
import * as selectors from '@app/dashboard/state/dashboard.selector';
import { Store } from '@ngrx/store';
import { DashboardState } from '@app/dashboard/state/dashboard.state';
import * as actions from '@app/dashboard/state/dashboard.actions';

@Injectable({ providedIn: 'root' })
export class DashboardFacade {
  activeMyWorkTab$ = this.store.select(selectors.getActiveMyWorkTab);
  activePills = this.store.select(selectors.getActivePills);
  activeMyTeamTab$ = this.store.select(selectors.getActiveMyTeamTab);

  constructor(private store: Store<DashboardState>) {}

  setActiveMyWorkTab(activeMyWorkTab: string) {
    this.store.dispatch(actions.changeActiveMyWorkTab({ activeMyWorkTab }));
  }
  setActiveMyTeamTab(activeMyTeamTab: string) {
    this.store.dispatch(actions.changeActiveMyTeamTab({ activeMyTeamTab }));
  }
  addActivePill(activePill: string, inactivePills: string[]) {
    this.store.dispatch(actions.addActivePill({ activePill, inactivePills }));
  }
}
